// Couche mince (sans test) de la remontee des erreurs du navigateur vers GlitchTip. Les
// decisions sont dans front/lib/compta/erreurs_sentry.ts. Sans NEXT_PUBLIC_SENTRY_DSN (lu au
// build, comme les autres NEXT_PUBLIC_*), rien n'est charge : @sentry/react n'entre meme pas
// dans le bundle initial, il n'est importe qu'a la demande quand un DSN est pose.
import {
  definirRapporteur,
  optionsSentry,
} from "@dust-tt/front/lib/compta/erreurs_sentry";

type Sdk = typeof import("@sentry/react");

export type IdentiteNavigateur = {
  utilisateur: string | null;
  workspace: string | null;
};

let demande = false;
let sdk: Sdk | null = null;
let identiteEnAttente: IdentiteNavigateur | null = null;

/** Vrai quand un DSN est pose et que la remontee a ete demandee au demarrage. */
export function sentrySpaDemarre(): boolean {
  return demande;
}

export function demarrerSentrySpa(): boolean {
  if (demande) {
    return true;
  }
  const options = optionsSentry({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environnement: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    release:
      process.env.NEXT_PUBLIC_SENTRY_RELEASE ??
      import.meta.env?.VITE_COMMIT_HASH,
  });
  if (!options) {
    return false;
  }
  demande = true;
  void import("@sentry/react")
    .then((Sentry) => {
      Sentry.init({
        ...options,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      });
      sdk = Sentry;
      definirRapporteur((erreur, contexte) => {
        Sentry.captureException(erreur, { tags: contexte });
      });
      if (identiteEnAttente) {
        appliquerIdentite(Sentry, identiteEnAttente);
      }
    })
    .catch(() => {
      // le SDK n'a pas pu se charger (reseau, bloqueur) : la page continue sans remontee
    });
  return true;
}

/** Identite minimale attachee aux evenements : sId du membre et du workspace, jamais l'e-mail. */
export function identifierPourSentry(identite: IdentiteNavigateur): void {
  identiteEnAttente = identite;
  if (sdk) {
    appliquerIdentite(sdk, identite);
  }
}

function appliquerIdentite(
  Sentry: Sdk,
  { utilisateur, workspace }: IdentiteNavigateur
): void {
  Sentry.setUser(
    utilisateur
      ? { id: utilisateur, ...(workspace ? { workspace } : {}) }
      : null
  );
  Sentry.setTag("workspace", workspace ?? undefined);
}
